import type { ChatMessageRole } from './chatMessageRole';

export interface ChatMessage {
  /** 메시지 내용 */
  content: string;
  /** 메시지 역할 */
  role: ChatMessageRole;
}
